import './Home.css'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Header } from '../../components/Header/Header.js'
import { BottomMenu } from '../../components/BottomMenu/BottomMenu'

const Home = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const authorized = localStorage.getItem('authorized')

	useEffect(() => {
		if (authorized === 'true') {
			navigate('/tournaments')
		}
	}, [authorized, navigate])

	const goLogin = () => { navigate('/login') }

	return (
		<>
			<Header
				className="header-container"
				backButton={false}
				subtitle={t('Tournaments')}
				info={true}
			/>

			<div className="home__viwer-container">
				<p className="home__viwer-title" onClick={goLogin}>
					<span className="home__viwer-title--blue">
						{t('Home login')}
					</span>

					<span> </span>

					{t('to your account to view tournaments')}
				</p>

				<p className="home__info-description">
					{t('No public tournaments')}
				</p>
			</div>

			<BottomMenu />
		</>
	)
}

export default Home
